setTimeout(function () {
    if(!supportedBrowsers.test(navigator.userAgent)) {
        document.getElementsByClassName('app-outdated-browser')[0].style.display = 'inline-block';
        document.getElementsByClassName('app-outdated-browser-ua')[0].innerHTML = navigator.userAgent;
    }
}, 0);